import axios from 'axios/index'

import config from '../../../config'
import action, { actionFailed } from '../../../util/action'
import consts from '../../../util/consts'
import createAsyncConst from '../../../util/createAsyncConst'

export const FETCH_CASHBACK_EXTRACT = createAsyncConst('FETCH_CASHBACK_EXTRACT')
export const FETCH_CASHBACK_EXTRACT_DETAILS = createAsyncConst(
  'FETCH_CASHBACK_EXTRACT_DETAILS'
)

export function fetchCashbackExtract(page, filters = {}, rows) {
  return dispatch => {
    dispatch(action(FETCH_CASHBACK_EXTRACT.ACTION))
    return axios
      .get(`${config.API_URL}/cashback-points`, {
        params: {
          ...filters,
          rows: rows || consts.DEFAULT_PAGINATION,
          page: page || 1,
        },
      })
      .then(resp => {
        dispatch(
          action(FETCH_CASHBACK_EXTRACT.SUCCESS, {
            data: resp.data,
            filters: filters,
          })
        )
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_CASHBACK_EXTRACT, e)))
  }
}

export function fetchCashbackDetails(filters) {
  return dispatch => {
    dispatch(action(FETCH_CASHBACK_EXTRACT_DETAILS.ACTION))
    return axios
      .get(`${config.API_URL}/cashback-points`, {
        params: {
          ...filters,
        },
      })
      .then(resp => {
        dispatch(
          action(FETCH_CASHBACK_EXTRACT_DETAILS.SUCCESS, {
            data: resp.data,
            filters: filters,
          })
        )
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_CASHBACK_EXTRACT_DETAILS, e)))
  }
}